module.exports = __webpack_public_path__ + "img/23.8f364faa.png";